import { types } from '../../../types/types';

export const loginValidaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGIN.VALIDAACESSO:
            result = action.payload;
            break;
        case types.LOGIN.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const codigoResetSenhaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGIN.CODIGO_RESETSENHA:
            result = action.payload;
            break;
        case types.LOGIN.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const codigoValidaCadReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGIN.CODIGO_VALIDACAD:
            result = action.payload;
            break;
        case types.LOGIN.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const validaCadReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGIN.VALIDACAD:
            result = action.payload;
            break;
        case types.LOGIN.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const pesquisaLoginReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGIN.PESQUISA:
            result = action.payload;
            break;
        case types.LOGIN.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const atualizaLoginReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGIN.ATUALIZALOGIN:
            result = action.payload;
            break;
        case types.LOGIN.INICIALOGIN:
            result = {};
            break;  
        default:
            result = state;
            break;
    }
    return result;
}